<template>
  <div class="PlayerMenu">
    <div class="PlayerMenu__item" :class="{'active': highlights}" @click="setHighlights(true)">Highlights</div>
    <div class="PlayerMenu__item" :class="{'active': plays}" @click="setPlays(true)">Plays</div>
    <div class="PlayerMenu__item" :class="{'active': players}" @click="setPlayers(true)">Players</div>
  </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex';

export default {
  name: 'PlayerMenu',
  data() {
    return {
    };
  },
  methods: {
    ...mapMutations(['setHighlights', 'setPlays', 'setPlayers']),
  },
  computed: {
    ...mapState(['highlights', 'plays', 'players']),
  },
};
</script>

<style lang="scss">
  .PlayerMenu {
    z-index: 100;
    position: absolute;
    top: 0;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 20px;
    width:100%;
    &__item{
      transition: all .5s ease;
      text-align: center;
      margin:0 10px;
      cursor: pointer;
      flex-basis: 200px;
      padding: 5px 20px;
      background: rgba(0, 0, 0, 0.4);
      color: rgba(255,255,255, 0.5);
      border-radius: 100px;
      &.active, &:hover{
        background: rgba(0, 0, 0, 0.7);
        color: #00acff;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/PlayerMenu.vue